import { createTypes, actionCreator } from 'redux-action-creator';
import { parseJSON, getCookie } from '../../utils'

export const offerTypes = createTypes([
    'REQUEST',
    'RECEIVE',
    'ERROR',
    'SUCCESS',
    'SET_STATE_MULTI',
    'SET_STALE',
    'CLEAR_PERSON',
    'TOGGLE_TYPE',
    'RECEIVE_CONTRACT',
    'ERROR_CONTRACT',
    'REQUEST_CONTRACT',
    'RECEIVE_TILBOD',
    'ERROR_TILBOD',
    'REQUEST_TILBOD',
    'RECEIVE_TILBOD_MULTI',
    'ERROR_TILBOD_MULTI',
    'REQUEST_TILBOD_MULTI',
    'RECEIVE_GENERATE_CONTRACT_FILES',
    'ERROR_GENERATE_CONTRACT_FILES',
    'REQUEST_GENERATE_CONTRACT_FILES',
    'RECEIVE_CONTRACT_STATUS',
    'ERROR_CONTRACT_STATUS',
    'REQUEST_CONTRACT_PDF',
    'RECEIVE_CONTRACT_PDF',
    'ERROR_CONTRACT_PDF',
    'REQUEST_CONTRACT_OVERVIEW_PDF',
    'RECEIVE_CONTRACT_OVERVIEW_PDF',
    'ERROR_CONTRACT_OVERVIEW_PDF',
    'REQUEST_SEND_CONTRACT',
    'RECEIVE_SEND_CONTRACT',
    'ERROR_SEND_CONTRACT',
    'REQUEST_DELETE_CONTRACT',
    'RECEIVE_DELETE_CONTRACT',
    'ERROR_DELETE_CONTRACT',
    'REQUEST_EXTEND_CONTRACT',
    'RECEIVE_EXTEND_CONTRACT',
    'ERROR_EXTEND_CONTRACT',
    'REQUEST_CHANGE_STATUS',
    'RECEIVE_CHANGE_STATUS',
    'ERROR_CHANGE_STATUS',
    'REQUEST_ADDITIONAL_ANSWERS',
    'RECEIVE_ADDITIONAL_ANSWERS',
    'ERROR_ADDITIONAL_ANSWERS'
], 'OFFERS');


export const requestOffer = (customerId, offerType) => {
    return {
        type: offerTypes.REQUEST,
        customerId: customerId, 
        offerType: offerType,
    };
};

export const receiveOffer = (response, customerId, type, portfolio) => {
    return {
        type: offerTypes.RECEIVE,
        customerId: customerId,
        offerType: type,
        data: response,
        portfolio: portfolio
    };
};

export const receiveOfferError = (response, customerId, type) => {
    return {
        type: offerTypes.ERROR,
        offerType: type,
        response: response,
        customerId: customerId,
    };
};

export const setMultiState = (params, customerId) => {
    return {
        type: offerTypes.SET_STATE_MULTI,
        data: params,
        customerId: customerId,
    }
}

export const setStale = (value) => {
    return {
        type: offerTypes.SET_STALE,
        isStale: value
    }
}

export const toggleType = (insuranceType, customerIds) => {
    return {
        type: offerTypes.TOGGLE_TYPE,
        insuranceType: insuranceType,
        customerIds: customerIds,
    }
}

export const clearPerson = (customerId) => {
    return {
        type: offerTypes.CLEAR_PERSON,
        customerId: customerId,
    }
}

export const fetchOffer = (data) => {
    let port = data.information[data.type + "Portfolio"] ? data.information[data.type + "Portfolio"] : ''
    if (data.type == "FOR"){
        port = data.information["RENPortfolio"]
    }
    return dispatch => {
        const apiUrl = `/api/v1/offer/`

        // customerId, type, information, gender

        dispatch(requestOffer(data.customerId, data.type));

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }

        return fetch(apiUrl, {
            headers: headers,
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
        })
        .then(response => {
            if (response.ok) {
                return response
            }
            else {
                dispatch(receiveOfferError(response, data.customerId, data.type, port))
                return response
            }
        })
        .then(parseJSON)
        .then(response => {

            try {
                dispatch(receiveOffer(response, data.customerId, data.type, port));
            } catch (e) {
                dispatch(receiveOfferError(response, data.customerId, data.type))
            }


        })
        .catch(() => dispatch(receiveOfferError({status: 'error'}, data.customerId, data.type)));
    };
};

export const requestContract = () => {
    return {
        type: offerTypes.REQUEST_CONTRACT,
    };
};

export const receiveContract = (response) => {
    return {
        type: offerTypes.RECEIVE_CONTRACT,
        data: response,
    };
};

export const receiveContractError = (response) => {
    return {
        type: offerTypes.ERROR_CONTRACT,
        response: response,
    };
};

export const createContract = (data) => {
    return dispatch => {
        const apiUrl = `/api/v1/contract/`

        dispatch(requestContract());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRFToken': getCookie("csrftoken"),
        }

        return fetch(apiUrl, {
            headers: headers,
            method: 'POST',
            body: data,
            credentials: 'include',
        })
        .then(parseJSON)
        .then(response => {
            if (response.status !== "error") {
                dispatch(receiveContract(response));    
            } else {
                dispatch(receiveContractError(response))
            }
            return response
        })
        .catch(() => dispatch(receiveContractError({status: 'error', error_list: ['Óvænt villa í netsamskiptum. Reyndu aftur eða hafðu samband við Allianz.']})));
    };
};

export const requestTilbod = () => {
    return {
        type: offerTypes.REQUEST_TILBOD,
    };
};

export const receiveTilbod = (response) => {
    return {
        type: offerTypes.RECEIVE_TILBOD,
        data: response,
    };
};

export const receiveTilbodError = (response) => {
    return {
        type: offerTypes.ERROR_TILBOD,
        response: response,
    };
};


export const fetchTilbod = (token, lite=false) => {
    return dispatch => {
        let apiUrl = `/api/v1/contract/${token}/`
        let success = true

        if (lite) {
            apiUrl = `${apiUrl}?lite=true` 
        }

        dispatch(requestTilbod());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRFToken': getCookie("csrftoken"),
        }

        return fetch(apiUrl, {
            headers: headers,
            method: 'GET',
            credentials: 'include',
        })
        .then(response => {
            if (response.status >= 400) {
                success = false
            }
            return response
        })
        .then(parseJSON)
        .then(response => {
            if (success) {
                dispatch(receiveTilbod(response));    
            } else {
                dispatch(receiveTilbodError(response))
            }
            return response
        })
        .catch(() => dispatch(receiveTilbodError({
            status:'error', 
            message:'Óvænt netvilla við að ná í tilboð. Vinsamlegast prufaðu að endurhlaða síðuna og reyna aftur eða hafðu samband við Allianz.'
        })));
    };
};


export const requestTilbodMulti = () => {
    return {
        type: offerTypes.REQUEST_TILBOD_MULTI,
    };
};

export const receiveTilbodMulti = (response) => {
    return {
        type: offerTypes.RECEIVE_TILBOD_MULTI,
        data: response,
    };
};

export const receiveTilbodMultiError = (response) => {
    return {
        type: offerTypes.ERROR_TILBOD_MULTI,
        response: response,
    };
};


export const fetchTilbodMulti = () => {
    return dispatch => {
        let apiUrl = `/api/v1/contracts/`
        let success = true

        dispatch(requestTilbodMulti());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRFToken': getCookie("csrftoken"),
        }

        return fetch(apiUrl, {
            headers: headers,
            method: 'GET',
            credentials: 'include',
        })
        .then(response => {
            if (response.status >= 400) {
                success = false
            }
            return response
        })
        .then(parseJSON)
        .then(response => {
            if (success) {
                dispatch(receiveTilbodMulti(response));    
            } else {
                dispatch(receiveTilbodMultiError(response))
            }
            return response
        })
        .catch(() => dispatch(receiveTilbodMultiError({
            status:'error', 
            message:'Óvænt netvilla við að ná í tilboð. Vinsamlegast prufaðu að endurhlaða síðuna og reyna aftur eða hafðu samband við Allianz.'
        })));
    };
};

export const fetchTilbodMultiCustomer = () => {
    return dispatch => {
        let apiUrl = `/api/v1/customercontracts/`
        let success = true

        dispatch(requestTilbodMulti());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRFToken': getCookie("csrftoken"),
        }

        return fetch(apiUrl, {
            headers: headers,
            method: 'GET',
            credentials: 'include',
        })
        .then(response => {
            if (response.status >= 400) {
                success = false
            }
            return response
        })
        .then(parseJSON)
        .then(response => {
            if (success) {
                dispatch(receiveTilbodMulti(response));    
            } else {
                dispatch(receiveTilbodMultiError(response))
            }
            return response
        })
        .catch(() => dispatch(receiveTilbodMultiError({
            status:'error', 
            message:'Óvænt netvilla við að ná í tilboð. Vinsamlegast prufaðu að endurhlaða síðuna og reyna aftur eða hafðu samband við Allianz.'
        })));
    };
};



export const requestContractOnlyPdf = () => {
    return {
        type: offerTypes.REQUEST_CONTRACT_PDF,
    };
};

export const receiveContractOnlyPdf = (response) => {
    return {
        type: offerTypes.RECEIVE_CONTRACT_PDF,
        data: response,
    };
};

export const receiveContractErrorOnlyPdf = (response) => {
    return {
        type: offerTypes.ERROR_CONTRACT_PDF,
        response: response,
    };
};

export const createContractOnlyPDF = (data) => {
    return dispatch => {
        const apiUrl = `/api/v1/contractonlypdf/`

        dispatch(requestContractOnlyPdf());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRFToken': getCookie("csrftoken"),
        }

        return fetch(apiUrl, {
            headers: headers,
            method: 'POST',
            body: data,
            credentials: 'include',
        })
        .then(parseJSON)
        .then(response => {
            if (response.status !== "error") {
                dispatch(receiveContractOnlyPdf(response));    
            } else {
                dispatch(receiveContractErrorOnlyPdf(response))
            }
            return response
        })
        .catch(() => dispatch(receiveContractErrorOnlyPdf({status:'error'})));
    };
};


export const requestGenerateContractFiles = () => {
    return {
        type: offerTypes.REQUEST_GENERATE_CONTRACT_FILES,
    };
};

export const receiveGenerateContractFiles = (response) => {
    return {
        type: offerTypes.RECEIVE_GENERATE_CONTRACT_FILES,
        data: response,
    };
};

export const receiveGenerateContractFilesError = (response) => {
    return {
        type: offerTypes.ERROR_GENERATE_CONTRACT_FILES,
        response: response,
    };
};


export const generateContractFiles = (token) => {
    return dispatch => {
        let apiUrl = `/api/v1/contract/${token}/?generate=true`

        dispatch(requestGenerateContractFiles());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRFToken': getCookie("csrftoken"),
        }

        return fetch(apiUrl, {
            headers: headers,
            method: 'GET',
            credentials: 'include',
        })
        .then(parseJSON)
        .then(response => {

            try {
                dispatch(receiveGenerateContractFiles(response));

            } catch (e) {
                console.log(e)
                dispatch(receiveGenerateContractFilesError(response))
            }


        })
        .catch(() => dispatch(receiveGenerateContractFilesError({status:'error'})));
    };
};


export const requestSendContract = () => {
    return {
        type: offerTypes.REQUEST_SEND_CONTRACT,
    };
};

export const receiveSendContract = (response) => {
    return {
        type: offerTypes.RECEIVE_SEND_CONTRACT,
        data: response,
    };
};

export const receiveSendContractError = (response) => {
    return {
        type: offerTypes.ERROR_SEND_CONTRACT,
        response: response,
    };
};


export const sendContract = (token) => {
    return dispatch => {
        let apiUrl = `/api/v1/contract/${token}/send/`

        dispatch(requestSendContract());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRFToken': getCookie("csrftoken"),
        }

        return fetch(apiUrl, {
            headers: headers,
            method: 'POST',
            credentials: 'include',
        })
        .then(parseJSON)
        .then(response => {
            if (response.status !== "error") {
                dispatch(receiveSendContract(response));    
            } else {
                dispatch(receiveSendContractError(response))
            }
            return response
        })
        .catch(() => dispatch(receiveSendContractError({status:'error',error_list:['Óvænt villa í netsamskiptum. Reyndu aftur eða hafðu samband við Allianz.']})));
    };
};



export const requestDeleteContract = () => {
    return {
        type: offerTypes.REQUEST_DELETE_CONTRACT,
    };
};

export const receiveDeleteContract = (response) => {
    return {
        type: offerTypes.RECEIVE_DELETE_CONTRACT,
        data: response,
    };
};

export const receiveDeleteContractError = (response) => {
    return {
        type: offerTypes.ERROR_DELETE_CONTRACT,
        response: response,
    };
};


export const deleteTilbod = (token) => {
    return dispatch => {
        let apiUrl = `/api/v1/contract/${token}/`

        dispatch(requestDeleteContract());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRFToken': getCookie("csrftoken"),
        }

        return fetch(apiUrl, {
            headers: headers,
            method: 'DELETE',
            credentials: 'include',
        })
        .then(parseJSON)
        .then(response => {
            if (response.status !== "error") {
                dispatch(receiveDeleteContract(response));    
            } else {
                dispatch(receiveDeleteContractError(response))
            }
            return response
        })

        .catch(() => dispatch(receiveDeleteContractError({status:'error'})));
    };
};



export const requestExtendContract = () => {
    return {
        type: offerTypes.REQUEST_EXTEND_CONTRACT,
    };
};

export const receiveExtendContract = (response) => {
    return {
        type: offerTypes.RECEIVE_EXTEND_CONTRACT,
        data: response,
    };
};

export const receiveExtendContractError = (response) => {
    return {
        type: offerTypes.ERROR_EXTEND_CONTRACT,
        response: response,
    };
};


export const extendTilbod = (token) => {
    return dispatch => {
        let apiUrl = `/api/v1/contract/${token}/extend/`

        dispatch(requestExtendContract());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRFToken': getCookie("csrftoken"),
        }

        return fetch(apiUrl, {
            headers: headers,
            method: 'POST',
            credentials: 'include',
        })
        .then(parseJSON)
        .then(response => {
            if (response.status !== "error") {
                dispatch(receiveExtendContract(response));    
            } else {
                dispatch(receiveExtendContractError(response))
            }
            return response
        })

        .catch(() => dispatch(receiveExtendContractError({status:'error'})));
    };
};



export const requestContractOverviewPdf = () => {
    return {
        type: offerTypes.REQUEST_CONTRACT_OVERVIEW_PDF,
    };
};

export const receiveContractOverviewPdf = (response) => {
    return {
        type: offerTypes.RECEIVE_CONTRACT_OVERVIEW_PDF,
        data: response,
    };
};

export const receiveContractErrorOverviewPdf = (response) => {
    return {
        type: offerTypes.ERROR_CONTRACT_OVERVIEW_PDF,
        response: response,
    };
};

export const createContractOverviewPDF = (data) => {
    return dispatch => {
        const apiUrl = `/api/v1/contractoverviewpdf/`

        dispatch(requestContractOverviewPdf());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRFToken': getCookie("csrftoken"),
        }

        return fetch(apiUrl, {
            headers: headers,
            method: 'POST',
            body: data,
            credentials: 'include',
        })
        .then(parseJSON)
        .then(response => {
            if (response.status !== "error") {
                dispatch(receiveContractOverviewPdf(response));    
            } else {
                dispatch(receiveContractErrorOverviewPdf(response))
            }
            return response
        })
        .catch(() => dispatch(receiveContractErrorOverviewPdf({status:'error'})));
    };
};



export const requestChangeStatus = () => {
    return {
        type: offerTypes.REQUEST_CHANGE_STATUS,
    };
};

export const receiveChangeStatus = (response) => {
    return {
        type: offerTypes.RECEIVE_CHANGE_STATUS,
        data: response,
    };
};

export const receiveChangeStatusError = (response) => {
    return {
        type: offerTypes.ERROR_CHANGE_STATUS,
        response: response,
    };
};


export const changeStatus = (token, type, customerId, status, subContractId) => {
    return dispatch => {
        let apiUrl = `/api/v1/contract/${token}/contractfilestatus/`

        dispatch(requestChangeStatus());

        let data = {
            token: token,
            type: type,
            customer_id: customerId,
            status: status,
            sub_contract_id: subContractId   
        }

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRFToken': getCookie("csrftoken"),
        }

        return fetch(apiUrl, {
            headers: headers,
            method: 'POST',
            credentials: 'include',
            body: JSON.stringify(data),

        })
        .then(parseJSON)
        .then(response => {
            if (response.status !== "error") {
                dispatch(receiveChangeStatus(response));    
            } else {
                dispatch(receiveChangeStatusError(response))
            }
            return response
        })

        .catch(() => dispatch(receiveChangeStatusError({status:'error'})));
    };
};

export const requestAdditionalAnswers = () => {
    return {
        type: offerTypes.REQUEST_ADDITIONAL_ANSWERS,
    };
};

export const receiveAdditionalAnswers = (response) => {
    return {
        type: offerTypes.RECEIVE_ADDITIONAL_ANSWERS,
        data: response,
    };
};

export const receiveAdditionalAnswersError = (response) => {
    return {
        type: offerTypes.ERROR_ADDITIONAL_ANSWERS,
        response: response,
    };
};



export const fetchAdditionalAnswers = (token) => {
    return dispatch => {
        let apiUrl = `/api/v1/additional_questions/${token}/answers`
        let success = true

        dispatch(requestAdditionalAnswers());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRFToken': getCookie("csrftoken"),
        }

        return fetch(apiUrl, {
            headers: headers,
            method: 'GET',
            credentials: 'include',
        })
        .then(response => {
            if (response.status >= 400) {
                success = false
            }
            return response
        })
        .then(parseJSON)
        .then(response => {
            if (success) {
                dispatch(receiveAdditionalAnswers(response));    
            } else {
                dispatch(receiveAdditionalAnswersError(response))
            }
            return response
        })
        .catch(() => dispatch(receiveAdditionalAnswersError({statua:'error', message:'Óvænt netvilla. Reyndu aftur eða hafðu sambandi við Allianz'})));
    };
};
